// export const LOADING = 'LOADING';  // Temporary
// export const TOKENISVALID = 'TOKENISVALID';  // Temporary
// export const TOKEN_ACCESS_RED = 'TOKEN_ACCESS_RED';  // Temporary

export const SET_ALL_PROGRAMS = "SET_ALL_PROGRAMS";
export const SET_ALL_SESSIONS = "SET_ALL_SESSIONS";
export const SET_ALL_SOUNDSCAPES = "SET_ALL_SOUNDSCAPES";
export const SET_ALL_VIDEO_PROGRAMS = "SET_ALL_VIDEO_PROGRAMS";
export const SET_ALL_SLEEP_PROGRAMS = "SET_ALL_SLEEP_PROGRAMS";
export const SET_ALL_BREATHE_PROGRAMS = "SET_ALL_BREATHE_PROGRAMS";
export const SET_ALL_ARTICLES = "SET_ALL_ARTICLES";
export const SET_ALL_TAGS = "SET_ALL_TAGS";
export const SET_ALL_USERS = "SET_ALL_USERS";
export const SET_ALL_DOCTORS = "SET_ALL_DOCTORS";
export const SET_ALL_PATIENTS = "SET_ALL_PATIENTS";
export const SET_IPD_PATIENTS = "SET_IPD_PATIENTS";
export const SET_OPD_PATIENTS = "SET_OPD_PATIENTS";
export const SET_ALL_CATEGORIES = "SET_ALL_CATEGORIES";
export const SET_ALL_QUOTES = "SET_ALL_QUOTES";
export const SET_ALL_JOURNAL_QUESTIONS = "SET_ALL_JOURNAL_QUESTIONS";

export const UPDATE_ALL_PROGRAMS = "UPDATE_ALL_PROGRAMS";
export const UPDATE_ALL_SESSIONS = "UPDATE_ALL_SESSIONS";
export const UPDATE_ALL_SOUNDSCAPES = "UPDATE_ALL_SOUNDSCAPES";
export const UPDATE_ALL_VIDEO_PROGRAMS = "UPDATE_ALL_VIDEO_PROGRAMS";
export const UPDATE_ALL_SLEEP_PROGRAMS = "UPDATE_ALL_SLEEP_PROGRAMS";
export const UPDATE_ALL_BREATHE_PROGRAMS = "UPDATE_ALL_BREATHE_PROGRAMS";
export const UPDATE_ALL_ARTICLES = "UPDATE_ALL_ARTICLES";
export const UPDATE_ALL_TAGS = "UPDATE_ALL_TAGS";
export const UPDATE_ALL_USERS = "UPDATE_ALL_USERS";
export const UPDATE_ALL_DOCTORS = "UPDATE_ALL_DOCTORS";
export const UPDATE_ALL_IPD_PATIENTS = "UPDATE_ALL_IPD_PATIENTS";
export const UPDATE_ALL_OPD_PATIENTS = "UPDATE_ALL_OPD_PATIENTS";
export const UPDATE_ALL_CATEGORIES = "UPDATE_ALL_CATEGORIES";
export const UPDATE_ALL_QUOTES = "UPDATE_ALL_QUOTES";
export const UPDATE_ALL_JOURNAL_QUESTIONS = "UPDATE_ALL_JOURNAL_QUESTIONS";

export const DELETE_SINGLE_PROGRAMS = "DELETE_SINGLE_PROGRAMS";
export const DELETE_SINGLE_SESSIONS = "DELETE_SINGLE_SESSIONS";
export const DELETE_SINGLE_SOUNDSCAPES = "DELETE_SINGLE_SOUNDSCAPES";
export const DELETE_SINGLE_VIDEO_PROGRAMS = "DELETE_SINGLE_VIDEO_PROGRAMS";
export const DELETE_SINGLE_SLEEP_PROGRAMS = "DELETE_SINGLE_SLEEP_PROGRAMS";
export const DELETE_SINGLE_BREATHE_PROGRAMS = "DELETE_SINGLE_BREATHE_PROGRAMS";
export const DELETE_SINGLE_ARTICLES = "DELETE_SINGLE_ARTICLES";
export const DELETE_SINGLE_TAGS = "DELETE_SINGLE_TAGS";
export const DELETE_SINGLE_USERS = "DELETE_SINGLE_USERS";
export const DELETE_SINGLE_DOCTORS = "DELETE_SINGLE_DOCTORS";
export const DELETE_SINGLE_PATIENTS = "DELETE_SINGLE_PATIENTS";
export const DELETE_SINGLE_CATEGORIES = "DELETE_SINGLE_CATEGORIES";
export const DELETE_SINGLE_QUOTES = "DELETE_SINGLE_QUOTES";
export const DELETE_SINGLE_JOURNAL_QUESTIONS = "DELETE_SINGLE_JOURNAL_QUESTIONS";

export const SHOW_SNACKBAR_ALERT = "SHOW_SNACKBAR_ALERT";
export const HIDE_SNACKBAR_ALERT = "HIDE_SNACKBAR_ALERT";

export default (state, action) => {
  switch (action.type) {
    // case LOADING: // Temporary
    //   return {
    //     ...state,
    //     loading: action.payload
    //   };
    // case TOKENISVALID: // Temporary
    //   return {
    //     ...state,
    //     tokenIsValid: action.payload
    //   };
    // case TOKEN_ACCESS_RED: // Temporary
    //   return {
    //     ...state,
    //     token_access: action.payload
    //   };

    case SET_ALL_PROGRAMS:
      return {
        ...state,
        all_programs: action.payload,
      };

    case SET_ALL_SESSIONS:
      return {
        ...state,
        all_sessions: action.payload,
      };

    case SET_ALL_SOUNDSCAPES:
      return {
        ...state,
        all_soundscapes: action.payload,
      };

    case SET_ALL_BREATHE_PROGRAMS:
      return {
        ...state,
        all_breathe_programs: action.payload,
      };

    case SET_ALL_SLEEP_PROGRAMS:
      return {
        ...state,
        all_sleep_programs: action.payload,
      };

    case SET_ALL_VIDEO_PROGRAMS:
      return {
        ...state,
        all_video_programs: action.payload,
      };

    case SET_ALL_ARTICLES:
      return {
        ...state,
        all_articles: action.payload,
      };

    case SET_ALL_USERS:
      return {
        ...state,
        all_users: action.payload,
      };

    case SET_ALL_DOCTORS:
      return {
        ...state,
        all_doctors: action.payload,
      };

    case SET_ALL_PATIENTS:
      return {
        ...state,
        all_patients: action.payload,
      };

    case SET_IPD_PATIENTS:
      return {
        ...state,
        ipd_patients: action.payload,
      };

    case SET_OPD_PATIENTS:
      return {
        ...state,
        opd_patients: action.payload,
      };

    case SET_ALL_CATEGORIES:
      return {
        ...state,
        all_categories: action.payload,
      };

    case SET_ALL_TAGS:
      return {
        ...state,
        all_tags: action.payload,
      };

    case SET_ALL_JOURNAL_QUESTIONS:
      return {
        ...state,
        all_journal_questions: action.payload,
      };

    case SET_ALL_QUOTES:
      return {
        ...state,
        all_quotes: action.payload,
      };

    case UPDATE_ALL_PROGRAMS:
      return {
        ...state,
        all_programs: [action.payload, ...state.all_programs],
      };

    case UPDATE_ALL_SESSIONS:
      return {
        ...state,
        all_sessions: [action.payload, ...state.all_sessions],
      };

    case UPDATE_ALL_SOUNDSCAPES:
      return {
        ...state,
        all_soundscapes: [action.payload, ...state.all_soundscapes],
      };

    case UPDATE_ALL_BREATHE_PROGRAMS:
      return {
        ...state,
        all_breathe_programs: [action.payload, ...state.all_breathe_programs],
      };

    case UPDATE_ALL_SLEEP_PROGRAMS:
      return {
        ...state,
        all_sleep_programs: [action.payload, ...state.all_sleep_programs],
      };

    case UPDATE_ALL_VIDEO_PROGRAMS:
      return {
        ...state,
        all_video_programs: [action.payload, ...state.all_video_programs],
      };

    case UPDATE_ALL_ARTICLES:
      return {
        ...state,
        all_articles: [action.payload, ...state.all_articles],
      };

    case UPDATE_ALL_CATEGORIES:
      return {
        ...state,
        all_categories: [action.payload, ...state.all_categories],
      };

    case UPDATE_ALL_CATEGORIES:
      return {
        ...state,
        all_categories: [action.payload, ...state.all_categories],
      };

    case UPDATE_ALL_TAGS:
      return {
        ...state,
        all_tags: [action.payload, ...state.all_tags],
      };

    case UPDATE_ALL_JOURNAL_QUESTIONS:
      return {
        ...state,
        all_journal_questions: [action.payload, ...state.all_journal_questions],
      };

    case UPDATE_ALL_QUOTES:
      return {
        ...state,
        all_quotes: [action.payload, ...state.all_quotes],
      };

    case UPDATE_ALL_USERS:
      return {
        ...state,
        all_users: [action.payload, ...state.all_users],
      };

    case UPDATE_ALL_DOCTORS:
      return {
        ...state,
        all_doctors: [action.payload, ...state.all_doctors],
      };

    case UPDATE_ALL_PATIENTS:
      return {
        ...state,
        all_patients: [action.payload, ...state.all_users],
      };
    case UPDATE_ALL_IPD_PATIENTS:
      return {
        ...state,
        ipd_patients: [action.payload, ...state.ipd_patients],
      };
    case UPDATE_ALL_OPD_PATIENTS:
      return {
        ...state,
        opd_patients: [action.payload, ...state.opd_patients],
      };
    case DELETE_SINGLE_PROGRAMS:
      return {
        ...state,
        all_programs: state.all_programs.filter((program) => program.id !== action.payload),
      };

    case DELETE_SINGLE_SESSIONS:
      return {
        ...state,
        all_sessions: state.all_sessions.filter((session) => session.id !== action.payload),
      };

    case DELETE_SINGLE_SOUNDSCAPES:
      return {
        ...state,
        all_soundscapes: state.all_soundscapes.filter(
          (soundscape) => soundscape.id !== action.payload
        ),
      };

    case DELETE_SINGLE_SLEEP_PROGRAMS:
      return {
        ...state,
        all_sleep_programs: state.all_sleep_programs.filter(
          (program) => program.id !== action.payload
        ),
      };

    case DELETE_SINGLE_VIDEO_PROGRAMS:
      return {
        ...state,
        all_video_programs: state.all_video_programs.filter(
          (program) => program.id !== action.payload
        ),
      };

    case DELETE_SINGLE_BREATHE_PROGRAMS:
      return {
        ...state,
        all_breathe_programs: state.all_breathe_programs.filter(
          (program) => program.id !== action.payload
        ),
      };

    case DELETE_SINGLE_ARTICLES:
      return {
        ...state,
        all_articles: state.all_articles.filter((article) => article.id !== action.payload),
      };

    case DELETE_SINGLE_CATEGORIES:
      return {
        ...state,
        all_categories: state.all_categories.filter((category) => category.id !== action.payload),
      };

    case DELETE_SINGLE_JOURNAL_QUESTIONS:
      return {
        ...state,
        all_journal_questions: state.all_journal_questions.filter(
          (question) => question.id !== action.payload
        ),
      };

    case DELETE_SINGLE_QUOTES:
      return {
        ...state,
        all_quotes: state.all_quotes.filter((quote) => quote.id !== action.payload),
      };

    case DELETE_SINGLE_TAGS:
      return {
        ...state,
        all_tags: state.all_tags.filter((tags) => tags.id !== action.payload),
      };

    case DELETE_SINGLE_USERS:
      return {
        ...state,
        all_users: state.all_users.filter((user) => user.user_id !== action.payload),
      };

    case DELETE_SINGLE_DOCTORS:
      return {
        ...state,
        all_doctors: state.all_doctors.filter((doctor) => doctor.user_id !== action.payload),
      };

    case DELETE_SINGLE_PATIENTS:
      return {
        ...state,
        all_patients: state.all_patients.filter((patient) => patient.id !== action.payload),
      };

    case SHOW_SNACKBAR_ALERT:
      return {
        ...state,
        snackbar_alert: {
          color: action.payload.color,
          title: action.payload.title,
          errorSB: action.payload.errorSB,
        },
      };

    case HIDE_SNACKBAR_ALERT:
      return {
        ...state,
        snackbar_alert: {
          ...state.snackbar_alert,
          errorSB: action.payload,
        },
      };
  }
};
